<template>
  <v-navigation-drawer app clipped stateless :value="true">
    <v-list dense>
      <v-list-item v-if="canViewCourses" link to="/manage/courses">
        <v-list-item-action>
          <v-icon>mdi-bookshelf</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Szkolenia</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="canViewUsers" link to="/manage/users">
        <v-list-item-action>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Użytkownicy</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="canViewGroups" link to="/manage/groups">
        <v-list-item-action>
          <v-icon>mdi-account-group</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Grupy</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="canViewSettings" link to="/manage/settings">
        <v-list-item-action>
          <v-icon>mdi-cog-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Ustawienia</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('account');

export default {
  computed: {
    ...mapGetters(['permissions']),
    canViewCourses() {
      return this.permissions.includes('Lms_Administration_Courses');
    },
    canViewUsers() {
      return this.permissions.includes('Pages_Users');
    },
    canViewGroups() {
      return this.permissions.includes('Lms_Administration_ManagesGroups');
    },
    canViewSettings() {
      return this.permissions.includes('Lms_Administration_Manage_Tenant_Settings');
    }
  }
};
</script>
